export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14585.27ee089b.jpg";